(() => {
  'use strict';
  if (window.PXFeelGuide) return;
  const models = new Set(['bouncy', 'embrace', 'fusion', 'honeycomb', 'plush']);
  const revision = '2026-07-15';
  const isPublicId = value => /^[A-Za-z0-9]{6}$/.test(String(value || ''));
  const validEmail = value => typeof value === 'string' && value.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  function eventBody(input) {
    if (!validEmail(input.email) || !models.has(input.primary_model) || !/^[a-f0-9-]{36}$/i.test(input.request_id)) throw new Error('Invalid guide request');
    const alternate = models.has(input.alternate_model) && input.alternate_model !== input.primary_model ? input.alternate_model : null;
    return {data: {type: 'event', attributes: {
      properties: {primary_model: input.primary_model, alternate_model: alternate, guide_version: 'px-feel-guide-v1', request_id: input.request_id, guide_requested: true, marketing_opt_in: input.marketing_opt_in === true},
      unique_id: input.request_id,
      metric: {data: {type: 'metric', attributes: {name: 'PX Feel Guide Requested'}}},
      profile: {data: {type: 'profile', attributes: {email: input.email.trim()}}}
    }}};
  }

  function subscriptionBody(email, listId, source = 'quiz') {
    if (!validEmail(email) || !isPublicId(listId) || !['quiz', 'footer'].includes(source)) throw new Error('Invalid subscription request');
    return {data: {type: 'subscription', attributes: {
      custom_source: source === 'quiz' ? 'PX Quiz result signup' : 'PX Homepage footer signup',
      profile: {data: {type: 'profile', attributes: {
        email: email.trim(),
        properties: {px_signup_source: source},
        subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
      }}}
    }, relationships: {list: {data: {type: 'list', id: listId}}}}};
  }

  function create({companyId, listId = '', fetch: requestFetch = window.fetch.bind(window)} = {}) {
    if (!isPublicId(companyId)) return null;
    const accepted = new Set();
    const subscriptions = new Set();
    const inFlight = new Map();
    async function post(path, body) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await requestFetch(`https://a.klaviyo.com/client/${path}/?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer',
          headers: {accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision},
          body: JSON.stringify(body), signal: controller.signal
        });
        if (response.status !== 202) throw new Error('Request not accepted');
      } finally { clearTimeout(timeout); }
    }
    async function perform(input) {
      const body = eventBody(input);
      if (!accepted.has(input.request_id)) {
        await post('events', body);
        accepted.add(input.request_id);
      }
      let marketing = 'not_requested';
      if (input.marketing_opt_in === true) {
        if (!isPublicId(listId)) return {guide_status: 'accepted', marketing_status: 'unavailable'};
        const subscriptionKey = input.email.trim().toLowerCase();
        if (subscriptions.has(subscriptionKey)) marketing = 'accepted';
        else {
          try {
            await post('subscriptions', subscriptionBody(input.email, listId));
            subscriptions.add(subscriptionKey);
            marketing = 'accepted';
          } catch (_) { marketing = 'failed'; }
        }
      }
      return {guide_status: 'accepted', marketing_status: marketing};
    }
    return {
      ready: true,
      marketingReady: isPublicId(listId),
      async subscribe({email, source, marketing_opt_in}) {
        if (marketing_opt_in !== true) throw new Error('Explicit subscription required');
        await post('subscriptions', subscriptionBody(email, listId, source));
        return {marketing_status: 'accepted'};
      },
      request(input) {
        const key = String(input.request_id || '');
        if (inFlight.has(key)) return inFlight.get(key);
        const pending = perform(input).finally(() => inFlight.delete(key));
        inFlight.set(key, pending);
        return pending;
      }
    };
  }
  window.PXFeelGuide = {create};
})();
